export default "__VITE_ASSET__B2g1tyOW__"